import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_5 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" }, "Active", -1);
const _hoisted_7 = { class: "mt-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Division Active Status", -1);
const _hoisted_9 = { class: "mr-2 flex flex-row align-center" };
const _hoisted_10 = ["id", "value", "name", "checked"];
const _hoisted_11 = ["for"];
const _hoisted_12 = ["for"];
const _hoisted_13 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_14 = ["id", "onUpdate:modelValue", "type", "name", "disabled", "onBlur"];
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { class: "text-red-600" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "my-8" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg text-center" }, "Sectors")
], -1);
const _hoisted_19 = { class: "flex justify-end my-4" };
const _hoisted_20 = {
    key: 0,
    class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
};
const _hoisted_21 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_22 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
const _hoisted_25 = {
    key: 1,
    class: "text-lg text-center text-gray-600"
};
const _hoisted_26 = {
    key: 1,
    class: "text-lg text-center text-gray-600"
};
const _hoisted_27 = { class: "pt-5" };
const _hoisted_28 = { class: "flex justify-end" };
const _hoisted_29 = ["disabled"];
import { ViewGridAddIcon, ViewGridIcon } from '@heroicons/vue/solid';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import SectorForm from '@/components/admin/admin-components/config/forms/SectorForm.vue';
import ModalWindow from '@/components/ModalWindow.vue';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DivisionForm',
    props: {
        selectedItem: {}
    },
    emits: ["close-modal", "refresh-config"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const showModal = ref(false);
        const selectedSector = ref(undefined);
        const formData = reactive({
            LKStatus: true,
            ID: '',
            NAME: '',
        });
        const fields = [
            {
                key: 'ID',
                label: 'ID',
                type: 'text',
                name: 'ID-field',
                id: 'ID-field',
            },
            {
                key: 'NAME',
                label: 'Division Name',
                type: 'text',
                name: 'name-field',
                id: 'name-field',
            },
        ];
        const rules = {
            formData: {
                LKStatus: { required },
                ID: { required },
                NAME: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const openModal = () => {
            showModal.value = true;
        };
        const closeModal = (payload) => {
            if (payload?.refresh) {
                emit('refresh-config');
            }
            showModal.value = false;
            selectedSector.value = undefined;
        };
        const handleClickSector = (sector) => {
            selectedSector.value = sector;
            openModal();
        };
        const handleCreateDivision = async () => {
            store.dispatch('setIsLoading', true);
            const payload = { type: 'division', ...formData };
            try {
                const response = await httpClient.post('/config/create', payload);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: props.selectedItem
                        ? 'Changes saved'
                        : 'Successfully created new Division',
                });
                emit('close-modal');
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: props.selectedItem
                        ? 'Error saving changes'
                        : 'Could not create new Division at this time.',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            if (props.selectedItem) {
                Object.assign(formData, props.selectedItem);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("form", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createTextVNode(),
                                    _createElementVNode("fieldset", _hoisted_7, [
                                        _hoisted_8,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_9, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (item) => {
                                                return _createElementVNode("div", {
                                                    key: item,
                                                    class: "flex items-center mr-6"
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: `LKStatus-${item.toString()}`,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.LKStatus) = $event)),
                                                        value: item,
                                                        name: `LKStatus-${item.toString()}`,
                                                        type: "radio",
                                                        checked: formData.LKStatus === item,
                                                        class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                    }, null, 8, _hoisted_10), [
                                                        [_vModelRadio, formData.LKStatus]
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("label", {
                                                        for: `LKStatus-${item.toString()}`,
                                                        class: "ml-3 block text-sm font-medium text-gray-700"
                                                    }, _toDisplayString(item.toString()), 9, _hoisted_11)
                                                ]);
                                            }), 64))
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
                                    return _createElementVNode("div", {
                                        key: field.id,
                                        class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
                                    }, [
                                        _createElementVNode("label", {
                                            for: field.name,
                                            class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                                        }, _toDisplayString(field.label), 9, _hoisted_12),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: field.id,
                                                "onUpdate:modelValue": ($event) => ((formData[field.key]) = $event),
                                                type: field.type,
                                                name: field.name,
                                                class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                disabled: _ctx.selectedItem,
                                                onBlur: ($event) => (_unref(v$).formData[field.key].$touch())
                                            }, null, 40, _hoisted_14), [
                                                [_vModelDynamic, formData[field.key]]
                                            ]),
                                            _createTextVNode(),
                                            (_unref(v$).formData[field.key].$error)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createElementVNode("p", _hoisted_16, "* " + _toDisplayString(_unref(v$).formData[field.key].$errors[0].$message), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]);
                                }), 64))
                            ]),
                            _createTextVNode(),
                            (_ctx.selectedItem)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _hoisted_18,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                            onClick: _withModifiers(openModal, ["prevent"])
                                        }, "Add Sector")
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.selectedItem?.SECTORS?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("table", _hoisted_21, [
                                                _createElementVNode("tbody", _hoisted_22, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItem?.SECTORS, (sector) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: sector.ID
                                                        }, [
                                                            _createElementVNode("td", {
                                                                class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline cursor-pointer",
                                                                onClick: _withModifiers(($event) => (handleClickSector(sector)), ["prevent"])
                                                            }, [
                                                                _createTextVNode(_toDisplayString(sector.NAME) + " ", 1),
                                                                (!sector.LKStatus)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Inactive"))
                                                                    : _createCommentVNode("", true)
                                                            ], 8, _hoisted_23)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_25, "No Sectors exist in this Division.."))
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_26, "You can only add Sectors to this Division once it has been saved..."))
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                                onClick: _cache[1] || (_cache[1] = ($event) => (emit('close-modal')))
                            }, "Cancel"),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: _unref(v$).$invalid,
                                type: "submit",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _withModifiers(handleCreateDivision, ["prevent"])
                            }, "Save", 8, _hoisted_29)
                        ])
                    ])
                ]),
                _createTextVNode(),
                (showModal.value)
                    ? (_openBlock(), _createBlock(ModalWindow, {
                        key: 0,
                        size: "5xl",
                        onClose: closeModal
                    }, {
                        icon: _withCtx(() => [
                            (selectedSector.value)
                                ? (_openBlock(), _createBlock(_unref(ViewGridIcon), {
                                    key: 0,
                                    class: "h-10 w-12 text-green-600",
                                    "aria-hidden": "true"
                                }))
                                : (_openBlock(), _createBlock(_unref(ViewGridAddIcon), {
                                    key: 1,
                                    class: "h-10 w-12 text-green-600",
                                    "aria-hidden": "true"
                                }))
                        ]),
                        title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedSector.value ? 'Edit Sector' : 'Add Sector'), 1)
                        ]),
                        subtitle: _withCtx(() => [
                            _createTextVNode("Please fill out all the sector details")
                        ]),
                        main: _withCtx(() => [
                            _createVNode(SectorForm, {
                                "division-id": _ctx.selectedItem?.ID,
                                "selected-sector": selectedSector.value,
                                onCancel: closeModal
                            }, null, 8, ["division-id", "selected-sector"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
